import { type MetaFunction } from '@remix-run/node';
import { Form, useSearchParams } from '@remix-run/react';
import { AuthenticityTokenInput } from 'remix-utils/csrf/react';
import { Logo } from '~/components/logo.tsx';
import { Card } from '~/components/ui/card.tsx';

import { StatusButton } from '~/components/ui/status-button.tsx';
import { useIsPending } from '~/utils/misc.ts';

export const meta: MetaFunction = () => {
  return [{ title: 'Login to Eclipse' }];
};

export default function Login() {
  const [searchParams] = useSearchParams();
  const loading = useIsPending();
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-700 px-4 sm:px-6 lg:px-8">
      <Card className="mx-auto max-w-md overflow-hidden rounded-xl border-none md:max-w-2xl">
        <div className="justify-center md:flex">
          <div className="md:flex-shrink-0">
            <div className="flex h-48 w-full items-center bg-zinc-800 object-cover p-4 md:h-full md:w-48">
              <Logo height={50} />
            </div>
          </div>
          <div className="bg-white p-8">
            <div className="text-body-sm font-semibold uppercase tracking-wide text-primary-foreground">
              Welcome to Eclipse
            </div>
            <h2 className="mt-1 block text-body-md font-medium leading-tight text-secondary">
              Please sign in to continue
            </h2>
            <div className="flex h-full grow flex-col">
              <Form action="/auth/auth0" method="post">
                <AuthenticityTokenInput />
                <input
                  type="hidden"
                  name="redirectTo"
                  value={searchParams.get('redirectTo') ?? undefined}
                />
                <div className="flex justify-center pt-4">
                  <StatusButton
                    className="bg-zinc-800 text-primary"
                    type="submit"
                    status={loading ? 'pending' : 'idle'}
                  >
                    Login
                  </StatusButton>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
